import { render, staticRenderFns } from "./SearchVideoView.vue?vue&type=template&id=4b06aace"
import script from "./SearchVideoView.vue?vue&type=script&lang=js"
export * from "./SearchVideoView.vue?vue&type=script&lang=js"
import style0 from "./SearchVideoView.vue?vue&type=style&index=0&id=4b06aace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports